import React, { forwardRef } from 'react';
import './ConfirmDialog.css';

const ConfirmDialog = forwardRef(({ message, onConfirm, onCancel }, ref) => {
  const handleOverlayClick = (event) => {
    if (event.target === event.currentTarget) {
      onCancel();
    }
  };

  return (
    <div className="confirm-dialog-overlay" onClick={handleOverlayClick} ref={ref}>
      <div className="confirm-dialog" onClick={(e) => e.stopPropagation()}>
        <p>{message}</p>
        <div className="confirm-dialog-buttons">
          <button
            className="confirm-dialog-button confirm"
            onClick={(e) => {
              e.stopPropagation();
              onConfirm();
            }}
          >
            Oui
          </button>
          <button
            className="confirm-dialog-button cancel"
            onClick={(e) => {
              e.stopPropagation();
              onCancel();
            }}
          >
            Non
          </button>
        </div>
      </div>
    </div>
  );
});

export default ConfirmDialog;
